import { Injectable, OnDestroy } from '@angular/core';
import { CmpsDialog, CmpsDialogRef } from '@cmps/ng-uikit';
import { filter, map, tap } from 'rxjs/operators';

import { AuthService } from '../../auth/auth.service';
import {
    takeUntilDestroy,
    TakeUntilDestroy,
} from '../../common/take-until-destroy.decorator';
import { useDispatcher, useStore } from '../../store.decorator';
import { CallStatusService, HubMethods } from '../core';

import { listMeetings } from './state/list-meetings.action';
import { receiveMeetings } from './state/receive-meetings.action';
import { reload } from './state/reload.action';
import { TranscriptImportDialogComponent } from './transcript-import-dialog.component';
import { transcriptImportDialogReducer } from './transcript-import-dialog.reducer';
import { TranscriptImportDialogState } from './transcript-import-dialog.state';

@Injectable({ providedIn: 'root' })
@TakeUntilDestroy()
export class TranscriptImportDialogService implements OnDestroy {
    state: TranscriptImportDialogState;

    /** @deprecated this is a workaround */
    waitingForUserSearch: boolean;

    /** @deprecated this is a workaround */
    waitingForImport: boolean;

    private _ref: CmpsDialogRef<TranscriptImportDialogComponent, any>;

    constructor(
        readonly callStatusService: CallStatusService,
        private readonly _authService: AuthService,
        private readonly _dialog: CmpsDialog,
    ) {
        this._bind();

        useStore(
            this,
            'teamsCall.transcriptImport',
            transcriptImportDialogReducer,
        );
    }

    ngOnDestroy(): void {
        this.close();
    }

    open(selectedUserId?: number): void {
        if (this._ref != null && !this._ref.closed) {
            return;
        }

        if (selectedUserId == null) {
            this.close();
            return;
        }

        useDispatcher(
            this,
            reload({
                userId: this._authService.user.id,
                selectedUserId,
            }),
        );

        this._ref = this._dialog.open(TranscriptImportDialogComponent, {
            disableOverlayOverflowHidden: true,
            overlayClass:
                'cmps-teamscall-transcript-import-dialog--overlay-class',
            portalClass:
                'cmps-teamscall-transcript-import-dialog--portal-class',
            portalWrapperClass:
                'cmps-teamscall-transcript-import-dialog--portal-wrapper-class',
            disableBackdrop: true,
            placement: 'top-right',
            canClose: (): boolean =>
                !this.waitingForUserSearch && !this.waitingForImport,
        });
    }

    close(): void {
        this._ref?.close();
    }

    private _bind(): void {
        this.callStatusService.message
            .pipe(
                filter((msg) => msg.hubMethod === HubMethods.OnMeetingList),
                map((msg) => msg.payload),
                filter((noti) => noti.token === this.state.currentRequestToken),
                tap((noti) => {
                    useDispatcher(
                        this,
                        receiveMeetings({ meetings: noti.meetings }),
                    );
                    if (noti.status === 'done') {
                        useDispatcher(
                            this,
                            listMeetings({
                                token: noti.token,
                                stop: true,
                            }),
                        );
                    }
                }),
                takeUntilDestroy(this),
            )
            .subscribe();
    }
}
